import { createContext } from 'react';
import { IVideoGuestContext } from '../../models';

export const VideoGuestContext = createContext({} as IVideoGuestContext);
